import { render, staticRenderFns } from "./diapositiva-8.vue?vue&type=template&id=6618e481&scoped=true&"
import script from "./diapositiva-8.vue?vue&type=script&lang=js&"
export * from "./diapositiva-8.vue?vue&type=script&lang=js&"
import style0 from "./diapositiva-8.vue?vue&type=style&index=0&id=6618e481&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6618e481",
  null
  
)

export default component.exports